<template>
    <section>
      <b-autocomplete
        v-if="showAutocomplete"
        v-model="searchedKeyword"
        field="value"
        clearable
        :key="key"
        :icon="icon"
        :size="size"
        :data="filteredDataArray"
        :placeholder="placeholder"
        @select="handleSelect"
      >
        <template #empty>No results found</template>
      </b-autocomplete>
      <b-field class="mt-3">
        <div v-if="columns">
          <b-taglist>
            <b-tag
              v-for="item in selected"
              closable
              :size="size"
              :key="item.id"
              aria-close-label="Close tag"
              @close="handleClose(item)"
            >
              {{ item }}
            </b-tag>
          </b-taglist>
        </div>
        <div v-else>
          <div v-for="item in selected" :key="item">
            <b-tag
              closable
              :size="size"
              aria-close-label="Close tag"
              @close="handleClose(item)"
            >
              {{ item }}
            </b-tag>
          </div>
        </div>
      </b-field>
    </section>
  </template>
  
  <script>
  export default {
    props: {
      icon: String,
      choices: Array,
      placeholder: String,
      columns: {
        type: Boolean,
        default: true,
      },
      onlyOne: {
        type: Boolean,
        default: false,
      },
      selected: {
        type: Array,
        default: () => [],
      },
      size: {
        type: String,
        default: 'is-small',
      },
    },
    data() {
      return {
        searchedKeyword: '',
        key: true,
      };
    },
    computed: {
      showAutocomplete() {
        return !(this.onlyOne && this.selected.length > 0);
      },
      filteredDataArray() {
        return this.choices.filter(option => {
          const searchedKeywordLowerCase = this.searchedKeyword.toLowerCase();
          const optionString = JSON.stringify(option.value);
          const optionStringLowerCase = optionString.toLowerCase();
          return optionStringLowerCase.includes(searchedKeywordLowerCase);
        });
      },
    },
    mounted() {
      this.$emit('list', this.selected);
    },
    methods: {
      columnCondition(val) {
        return this.columns ? val : '';
      },
      remove(val, list) {
        const index = list.indexOf(val);
  
        if (index > -1) {
          list.splice(index, 1);
        }
      },
      handleClose(item) {
        this.choices.push(item);
        this.remove(item, this.selected);
        this.$emit('list', this.selected);
      },
      handleSelect(option) {
        if (option) {
          this.selected.push(option.value);
          this.remove(option, this.choices);
          this.$emit('list', this.selected);
          this.key = !this.key;
          this.searchedKeyword = '';
        }
      },
    },
  };
  </script>
  